import { useCallback, useEffect, useState } from 'react';
import { Button, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import StarChefVisitService from '../../services/StarChefVisitService';

interface InputProps {
    houseId: number;
}

const starChefVisit = new StarChefVisitService();

const COLUMNS: CommonListColumn[] = [
    { label: 'Id', field: 'id' },
    { label: 'Status', field: 'status', type: 'status' },
    { label: 'Visit Date', field: 'visitDate' },
    { label: 'Visit Time', field: 'visitTime' },
    { label: 'House Id', field: 'houseId' },
    { label: 'Created By Type', field: 'createdByType' },
    { label: 'Cancellation Reason', field: 'cancellationReason' },
    {
        label: 'Actions',
        stopRowClick: true,
        render: (row) => (
            <Link href={`/#/StarChefVisit/${row.id}/show`}>
                <Button variant="contained" color="primary" size="small">Show</Button>
            </Link>
        ),
    },
];

const HousesStarChefVisitsTab = ({ houseId }: InputProps) => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const refreshData = useCallback(() => {
        setLoading(true);
        starChefVisit
            .getStarChefVisitForHouse(houseId)
            .then((res: any) => {
                setData(res?.data ?? []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [houseId]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    return (
        <CommonListTable
            columns={COLUMNS}
            data={data}
            loading={loading}
            emptyText="No Star Chef Visit Found"
        />
    );
};

export default HousesStarChefVisitsTab;
